import React, { useState } from 'react'
import { Fieldset } from 'primereact/fieldset'
import { FaChevronDown, FaChevronUp, FaPlus } from 'react-icons/fa'
import {
  Btn,
  CustomDropdown,
  CustomInputTextArea,
  InputText,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import * as colors from '../../../../assets/js/colors'
import AcoesLinha from './AcoesLinha'
import OpcoesResposta from './OpcoesResposta'
import { FIELD_TYPES, LIMITES, resumoRespostas, SIM_NAO } from '../shared/checklist.util'

const styles = {
  cabecalho: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  dica: { color: colors.gray, fontSize: '0.8rem', marginTop: 10 },
  acoes: { display: 'flex', alignItems: 'flex-end', paddingBottom: 10 },
  etapa: { marginTop: 15 },
  grupo: {
    marginTop: 15,
    padding: '0 15px 15px 15px',
    border: '1px solid #f0f0f0',
    borderLeft: `3px solid ${colors.azul}`,
  },
  item: { borderTop: '1px solid #f0f0f0', marginTop: 10 },
  numero: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingBottom: 18,
    color: colors.azul,
    fontWeight: 'bold',
  },
  resumo: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: '0.8rem',
    color: colors.gray,
  },
  respostas: { borderLeft: `3px solid ${colors.laranja}`, paddingLeft: 15, marginTop: 5 },
  rodape: { marginTop: 10 },
}

const ItemAvaliacao = React.memo(function ItemAvaliacao({
  item,
  etapaId,
  grupoId,
  indice,
  primeiro,
  ultimo,
  unico,
  autoFocus,
  localDispatch,
}) {
  const [expandido, setExpandido] = useState(false)

  const onChange = (chave, valor) =>
    localDispatch.onItemChange(etapaId, grupoId, item.id, chave, valor)

  return (
    <div style={styles.item}>
      <div className="p-grid">
        <div className="p-md-1 p-col-12" style={styles.numero}>
          {indice + 1}
        </div>
        <div className="p-md-7 p-col-12">
          <InputText
            label="Descrição do item:*"
            marginTop={10}
            maxLength={LIMITES.descricaoItem}
            autoFocus={autoFocus}
            value={item.item_name}
            onChange={value => onChange('item_name', value)}
            onEnter={() => localDispatch.onAdicionarItem(etapaId, grupoId, item.id)}
          />
        </div>
        <div className="p-md-2 p-col-12">
          <CustomDropdown
            label="Tipo de campo:*"
            marginTop={10}
            optionLabel="label"
            options={FIELD_TYPES}
            value={FIELD_TYPES.find(tipo => tipo.value === item.field_type) || null}
            onChange={value => value && onChange('field_type', value.value)}
          />
        </div>
        <div className="p-md-2 p-col-12" style={styles.acoes}>
          <AcoesLinha
            primeiro={primeiro}
            ultimo={ultimo}
            podeRemover={!unico}
            onMover={direcao => localDispatch.onMoverItem(etapaId, grupoId, item.id, direcao)}
            onDuplicar={() => localDispatch.onDuplicarItem(etapaId, grupoId, item.id)}
            onRemover={() => localDispatch.onRemoverItem(etapaId, grupoId, item.id)}
          />
        </div>
        <div className="p-md-1 p-col-12" />
        <div className="p-md-11 p-col-12" style={{ paddingTop: 0 }}>
          {item.field_type === 'dropdown' ? (
            <>
              <div style={styles.resumo}>
                <span>Respostas: {resumoRespostas(item)}</span>
                <TextBtn onClick={() => setExpandido(!expandido)}>
                  {expandido ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                  <span style={{ marginLeft: 5 }}>
                    {expandido ? 'Ocultar respostas' : 'Editar respostas'}
                  </span>
                </TextBtn>
              </div>
              {expandido ? (
                <div style={styles.respostas}>
                  <OpcoesResposta
                    opcoes={item.options}
                    comResultado
                    onChange={opcoes => onChange('options', opcoes)}
                  />
                </div>
              ) : null}
            </>
          ) : null}
          {item.field_type === 'checkbox' ? (
            <div style={{ maxWidth: 220 }}>
              <CustomDropdown
                label="Resposta de sucesso:*"
                marginTop={0}
                optionLabel="label"
                options={SIM_NAO}
                value={SIM_NAO.find(opcao => opcao.value === (item.success_value !== false))}
                onChange={value => value && onChange('success_value', value.value)}
              />
            </div>
          ) : null}
          {item.field_type !== 'dropdown' && item.field_type !== 'checkbox' ? (
            <div style={styles.resumo}>Campo informativo: não entra na pontuação.</div>
          ) : null}
        </div>
      </div>
    </div>
  )
})

const Grupo = React.memo(function Grupo({
  grupo,
  etapaId,
  indice,
  primeiro,
  ultimo,
  unico,
  caminho,
  focoId,
  localDispatch,
}) {
  return (
    <div style={styles.grupo}>
      <div className="p-grid">
        <div className="p-md-10 p-col-12">
          <InputText
            label={`Grupo ${indice + 1} - Nome:*`}
            marginTop={10}
            maxLength={LIMITES.nome}
            value={grupo.group_name}
            onChange={value => localDispatch.onGrupoChange(etapaId, grupo.id, 'group_name', value)}
          />
        </div>
        <div className="p-md-2 p-col-12" style={styles.acoes}>
          <AcoesLinha
            primeiro={primeiro}
            ultimo={ultimo}
            podeRemover={!unico}
            onMover={direcao => localDispatch.onMoverGrupo(etapaId, grupo.id, direcao)}
            onRemover={() =>
              localDispatch.onSolicitarRemocao({
                etapaId,
                grupoId: grupo.id,
                mensagem: `Tem certeza que deseja remover o ${caminho} e os seus ${grupo.items.length} itens?`,
              })
            }
          />
        </div>
      </div>
      {grupo.items.map((item, itemIndice) => (
        <ItemAvaliacao
          key={item.id}
          item={item}
          etapaId={etapaId}
          grupoId={grupo.id}
          indice={itemIndice}
          primeiro={itemIndice === 0}
          ultimo={itemIndice === grupo.items.length - 1}
          unico={grupo.items.length === 1}
          autoFocus={item.id === focoId}
          localDispatch={localDispatch}
        />
      ))}
      {grupo.items.length < LIMITES.itensPorGrupo ? (
        <div style={styles.rodape}>
          <TextBtn onClick={() => localDispatch.onAdicionarItem(etapaId, grupo.id)}>
            <FaPlus size={10} style={{ marginRight: 5 }} />
            Adicionar item
          </TextBtn>
        </div>
      ) : null}
    </div>
  )
})

const Etapa = React.memo(function Etapa({
  etapa,
  indice,
  primeiro,
  ultimo,
  unico,
  focoId,
  localDispatch,
}) {
  const totalItens = etapa.groups.reduce((total, grupo) => total + grupo.items.length, 0)

  return (
    <div style={styles.etapa}>
      <Fieldset legend={`Etapa ${indice + 1}`} toggleable>
        <div className="p-grid">
          <div className="p-md-10 p-col-12">
            <InputText
              label="Nome da etapa:*"
              marginTop={0}
              maxLength={LIMITES.nome}
              value={etapa.step_name}
              onChange={value => localDispatch.onEtapaChange(etapa.id, 'step_name', value)}
            />
          </div>
          <div className="p-md-2 p-col-12" style={styles.acoes}>
            <AcoesLinha
              primeiro={primeiro}
              ultimo={ultimo}
              podeRemover={!unico}
              onMover={direcao => localDispatch.onMoverEtapa(etapa.id, direcao)}
              onRemover={() =>
                localDispatch.onSolicitarRemocao({
                  etapaId: etapa.id,
                  grupoId: null,
                  mensagem: `Tem certeza que deseja remover a Etapa ${
                    indice + 1
                  } e os seus ${totalItens} itens?`,
                })
              }
            />
          </div>
          <div className="p-col-12">
            <CustomInputTextArea
              label="Orientações da etapa (opcional)"
              marginTop={0}
              rows={2}
              value={etapa.instructions}
              onChange={value => localDispatch.onEtapaChange(etapa.id, 'instructions', value)}
            />
          </div>
        </div>
        {etapa.groups.map((grupo, grupoIndice) => (
          <Grupo
            key={grupo.id}
            grupo={grupo}
            etapaId={etapa.id}
            indice={grupoIndice}
            primeiro={grupoIndice === 0}
            ultimo={grupoIndice === etapa.groups.length - 1}
            unico={etapa.groups.length === 1}
            caminho={`Grupo ${grupoIndice + 1} da Etapa ${indice + 1}`}
            focoId={focoId}
            localDispatch={localDispatch}
          />
        ))}
        {etapa.groups.length < LIMITES.grupos ? (
          <div style={styles.rodape}>
            <TextBtn onClick={() => localDispatch.onAdicionarGrupo(etapa.id)}>
              <FaPlus size={10} style={{ marginRight: 5 }} />
              Adicionar grupo
            </TextBtn>
          </div>
        ) : null}
      </Fieldset>
    </div>
  )
})

export default function CorpoChecklist({ etapas, totalItens, focoId, localDispatch }) {
  return (
    <div style={{ marginTop: 10 }}>
      <SectionTitle title="Corpo" />
      <div style={styles.cabecalho}>
        <span style={styles.dica}>
          {etapas.length} etapa(s) e {totalItens} item(ns) de avaliação. Pressione Enter na
          descrição de um item para criar o próximo.
        </span>
        {etapas.length < LIMITES.etapas ? (
          <Btn onClick={localDispatch.onAdicionarEtapa}>
            <FaPlus style={{ marginRight: 5 }} size={10} />
            Adicionar etapa
          </Btn>
        ) : null}
      </div>
      {etapas.map((etapa, indice) => (
        <Etapa
          key={etapa.id}
          etapa={etapa}
          indice={indice}
          primeiro={indice === 0}
          ultimo={indice === etapas.length - 1}
          unico={etapas.length === 1}
          focoId={focoId}
          localDispatch={localDispatch}
        />
      ))}
    </div>
  )
}
